<header id="header" class="header">
  <div class="header-page">
    <a *ngIf="(page$ | async) !== 'on-demand'" class="toggle-offcanvas" id="hamburger-link" (click)="toggleNav()">
      <span id="hamburger-span"></span>
    </a>
    <a (click)="goToPage()">
      <img
        class="header-page-logo"
        id="header-page-logo"
        [src]="logoPath"
        alt="Relaxnews - My editorializer"
        title="Relaxnews - My editorializer"
      />
    </a>
    <div class="header-page-actions" [ngClass]="{ 'expanded-searchBox': hasExpandedSearchBox }">
      <ul class="left-menu-nav">
        <li class="active">
          <a id="select-nav" class="header-element" (click)="goToPage()">{{ 'SELECT' | translate }}</a>
        </li>
        <!--<li>
          <a (click)="goToPage()">{{'PUBLISH' | translate}}</a>
        </li>-->
        <li>
          <a id="on-demand-nav" (click)="goToOrderOnDemandPage()">{{ 'ON_DEMAND' | translate }}</a>
        </li>
      </ul>
      <ul class="right-menu-nav" [ngClass]="{ 'nav-open': navOpen === true }">
        <!--<li class="header-search-box">
          <form (submit)="searchString(searchBar.value, $event)">
            <label for="header-search-input"></label
            ><input
              id="header-search-input"
              #searchBar
              placeholder="{{ 'TYPE_TO_SEARCH' | translate }}"
              [value]="searchTerms"
              name="searchBar"
              [formControl]="searchControl"
              autocomplete="off"
            />
          </form>

          <app-suggest-list
            [isOpenSuggestList]="isOpenSuggestList$ | async"
            (querySuggest$)="searchString($event.query, $event.event)"
            [suggestData]="suggestResponse$ | async"
            [searchQuery]="searchTerms$ | async"
            [isSuggestLoading]="isSuggestLoading$ | async"
            [isSuggestLoaded]="isSuggestLoaded$ | async"
          >
          </app-suggest-list>

          <div class="header-search-button" id="header-search" (click)="expandSearchBox()">
            <i id="search-icon" class="fa fa-search"></i>
          </div>
          <div class="close-search-button" (click)="clearSearchTerm()">
            <i class="fa fa-close"></i>
          </div>
          <div class="save-search-button">
            <i class="fa fa-star-o"></i>
          </div>
        </li>-->
        <li ngbDropdown placement="bottom-right" class="header-page-lang">
          <div [ngSwitch]="lang">
            <span *ngSwitchCase="'fr'" class="dropdown-item" ngbDropdownToggle> FR </span>
            <span *ngSwitchCase="'en'" class="dropdown-item" ngbDropdownToggle> EN </span>
            <span *ngSwitchCase="'en-fr'" class="dropdown-item" ngbDropdownToggle> EN+FR </span>
            <div ngbDropdownMenu>
              <span class="dropdown-item fr" *ngIf="lang !=='fr'" ngbDropdownItem [routerLink]="[currentUrl, 'fr']"
                >FR</span
              >
              <span class="dropdown-item en" *ngIf="lang !=='en'" ngbDropdownItem [routerLink]="[currentUrl, 'en']"
                >EN</span
              >
              <span
                class="dropdown-item en-fr"
                *ngIf="lang !=='en-fr'"
                ngbDropdownItem
                [routerLink]="[currentUrl, 'en-fr']"
                >EN-FR</span
              >
            </div>
          </div>
        </li>
        <li class="header-page-notifications">
          <i id="bell-icon" class="fa fa-bell"></i>
        </li>
        <li>
          <i class="fa fa-paint-brush" aria-hidden="true" (click)="openModal()"></i>
        </li>
        <li ngbDropdown placement="bottom-right" class="header-page-user">
          <div ngbDropdownToggle class="user-btn" [ngClass]="{ logged: isLogged }">
            <span class="user-icon">
              <i id="user-icon" class="fa fa-user"></i>
            </span>
            <span *ngIf="isLogged" class="user-name" id="user-name"> {{ (user$ | async)?.username }} </span>
          </div>
          <div ngbDropdownMenu class="user-account">
            <ul *ngIf="isLogged">
              <li>
                <a class="dropdown-item" (click)="goToPreferencesPage()">
                  <i class="fa fa-gear"></i>{{ 'PREFERENCES' | translate }}</a
                >
              </li>
              <li>
                <a [routerLink]="['./', 'bookmarks', 'all', lang]" class="dropdown-item"
                  ><i class="fa fa-gear"></i>{{ 'ALL_MY_SAVED_ITEMS' | translate }}</a
                >
              </li>
              <li>
                <a [routerLink]="" class="dropdown-item"><i class="fa fa-gear"></i>{{ 'PUBLISH' | translate }}</a>
              </li>
              <li>
                <a (click)="logout()" class="dropdown-item"><i class="fa fa-gear"></i>{{ 'LOG_OUT' | translate }}</a>
              </li>
            </ul>
            <ul *ngIf="!isLogged">
              <li>
                <a [routerLink]="['/login']" class="dropdown-item"
                  ><i class="fa fa-gear"></i>{{ 'LOGIN' | translate }}</a
                >
              </li>
              <li>
                <a [routerLink]="" class="dropdown-item"><i class="fa fa-gear"></i>{{ 'REGISTER' | translate }}</a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</header>
